import React, { useRef, useLayoutEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import GatsbyImage from 'gatsby-image'

export const ImageZoom = ({ image, setImageZoom }) => {
  const scrollContainer = useRef()

  useLayoutEffect(() => {
    const image = scrollContainer.current.querySelector('[aria-hidden="true"]')
    const halfHeight = image.getBoundingClientRect().height / 2
    const halfContainerHeight =
      scrollContainer.current.getBoundingClientRect().height / 2
    const scrollY = halfHeight - halfContainerHeight
    const halfWidth = image.getBoundingClientRect().width / 2
    const halfContainerWidth =
      scrollContainer.current.getBoundingClientRect().width / 2
    const scrollX = halfWidth - halfContainerWidth
    scrollContainer.current.scrollLeft = scrollX
    scrollContainer.current.scrollTop = scrollY
  }, [])

  return (
    <StyledImageZoom>
      <Close onClick={() => setImageZoom({ isOpen: false, image: null })}>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18'>
          <path d='M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z' />
        </svg>
      </Close>
      <Wrapper ref={scrollContainer}>
        <StyledImage fluid={image.fluid} alt={image.title} />
      </Wrapper>
    </StyledImageZoom>
  )
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const StyledImageZoom = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background: #f6f6f6;
  z-index: 90;
`

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: auto;
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    animation: ${fadeIn} 0.4s;
    border: 1px solid ${(props) => props.theme.colors.mediumGrey};
    &::-webkit-scrollbar {
      display: none;
    }
  }
`

const StyledImage = styled(GatsbyImage)`
  width: 230%;
  height: auto;
  position: relative;
  animation: ${fadeIn} 0.4s;
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    width: 200%;
    height: auto;
  }
`

const Close = styled.button`
  position: absolute;
  top: 8vw;
  right: 7vw;
  z-index: 91;
  cursor: pointer;
  animation: ${fadeIn} 0.4s;
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    top: 3vw;
    right: 3vw;
  }

  svg {
    width: 6.5vw;
    height: 6.5vw;
    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      width: 2vw;
      height: 2vw;
    }
  }
`
